import React from "react";
import { useContentContext } from "../context/content-context";

import ThemedPageWrapper from "../components/themed-page-wrapper";

const VideoPage = () => {
  const {
    videoPageInfo: { video, poster },
    content,
    isHCP,
  } = useContentContext();

  return (
    <ThemedPageWrapper>
      <section
        className={
          isHCP ? "section-outer hcp" : "section-outer background-light-teal"
        }
      >
        <div className="section-inner">
          <video poster={poster} controls={true} width="100%">
            <source src={video} />
          </video>
        </div>
      </section>
      <div dangerouslySetInnerHTML={{ __html: content?.join("") }} />
    </ThemedPageWrapper>
  );
};

export default VideoPage;
